import WidgetPlaceholder from './WidgetPlaceholder';
export type { WidgetPlaceholderProps } from './WidgetPlaceholder.types';

export default WidgetPlaceholder;
